import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  GetEssentialPropertiesResponse,
  GetSiteMetadataOptions,
  GetSiteMetadataResponse,
  ListSiteScriptsOptions,
  ListSiteScriptsResponse,
  getEssentialProperties as universalGetEssentialProperties,
  getSiteMetadata as universalGetSiteMetadata,
  listSiteScripts as universalListSiteScripts,
} from './assets-v1-site-script-scripts.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/headless-site-assets' };

export function listSiteScripts(
  httpClient: HttpClient
): ListSiteScriptsSignature {
  return (options?: ListSiteScriptsOptions) =>
    universalListSiteScripts(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface ListSiteScriptsSignature {
  /**
   * Retrieves a list of up to 100 site scripts
   */
  (options?: ListSiteScriptsOptions): Promise<
    NonNullablePaths<
      ListSiteScriptsResponse,
      | `siteScripts`
      | `siteScripts.${number}.position`
      | `siteScripts.${number}.html`,
      4
    >
  >;
}

export function getEssentialProperties(
  httpClient: HttpClient
): GetEssentialPropertiesSignature {
  return () =>
    universalGetEssentialProperties(
      // @ts-ignore
      { httpClient }
    );
}

interface GetEssentialPropertiesSignature {
  /**
   * Retrieves the essential properties of the site
   */
  (): Promise<
    NonNullablePaths<
      GetEssentialPropertiesResponse,
      | `properties.locale.languageCode`
      | `properties.locale.country`
      | `properties.multilingual.autoRedirect`
      | `properties.multilingual.supportedLanguages`
      | `properties.multilingual.supportedLanguages.${number}.languageCode`
      | `properties.multilingual.supportedLanguages.${number}.countryCode`
      | `properties.multilingual.supportedLanguages.${number}.isPrimary`
      | `properties.multilingual.supportedLanguages.${number}.isVisitorPrimary`
      | `properties.multilingual.supportedLanguages.${number}.resolutionMethod`,
      6
    >
  >;
}

export function getSiteMetadata(
  httpClient: HttpClient
): GetSiteMetadataSignature {
  return (options?: GetSiteMetadataOptions) =>
    universalGetSiteMetadata(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetSiteMetadataSignature {
  /**
   * Retrieves site metadata including both site scripts and essential properties
   */
  (options?: GetSiteMetadataOptions): Promise<
    NonNullablePaths<
      GetSiteMetadataResponse,
      | `siteScripts`
      | `siteScripts.${number}.position`
      | `siteScripts.${number}.html`
      | `properties.locale.languageCode`
      | `properties.locale.country`
      | `properties.multilingual.autoRedirect`
      | `properties.multilingual.supportedLanguages`
      | `properties.multilingual.supportedLanguages.${number}.languageCode`
      | `properties.multilingual.supportedLanguages.${number}.countryCode`
      | `properties.multilingual.supportedLanguages.${number}.isPrimary`
      | `properties.multilingual.supportedLanguages.${number}.isVisitorPrimary`
      | `properties.multilingual.supportedLanguages.${number}.resolutionMethod`,
      6
    >
  >;
}

export {
  EssentialProperties,
  GetEssentialPropertiesRequest,
  GetEssentialPropertiesResponse,
  GetSiteMetadataOptions,
  GetSiteMetadataRequest,
  GetSiteMetadataResponse,
  ListSiteScriptsOptions,
  ListSiteScriptsRequest,
  ListSiteScriptsResponse,
  Locale,
  Multilingual,
  PositionOnPage,
  ResolutionMethod,
  SiteScript,
  SupportedLanguage,
} from './assets-v1-site-script-scripts.universal.js';
